import _ from 'lodash';

export const root = (state) => _.get(state, 'CommonState.pageStateCache');



// WEBPACK FOOTER //
// ./src/state/pagestatecache/selectors.js